import { UserData } from '../../types/user';
import { CostBreakdown } from '../../types/renovation';
import { Language } from '../../types/language';

export function formatUserDataForFirestore(data: UserData, breakdown: CostBreakdown[], language: Language) {
  return {
    email: data.email.trim().toLowerCase(),
    services: breakdown.map(item => ({
      serviceName: language === 'fr' ? item.categoryFr : item.category,
      area: Number(item.details.area.toFixed(2)),
      cost: Number(item.cost.toFixed(2))
    })),
    totalCost: Number(data.totalCost?.toFixed(2)) || 0,
    language: language,
    timestamp: new Date().toISOString()
  };
}